import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-367.000000, -711.000000)" fill={color}>
                <g id="Group-10" transform="translate(346.000000, 555.000000)">
                    <g id="Group-7" transform="translate(16.000000, 153.000000)">
                        <path d="M16.3334309,9.66666667 C16.7015669,9.66666667 17,9.96483792 17,10.3313534 L17,14.3353132 C17,14.7024096 16.7033691,15 16.3334309,15 L5.66656909,15 C5.29843315,15 5,14.7018287 5,14.3353132 L5,10.3313534 C5,9.96425707 5.29663086,9.66666667 5.66656909,9.66666667 L16.3334309,9.66666667 Z M15.6666667,11 L6.33333333,11 L6.33333333,13.6666667 L15.6666667,13.6666667 L15.6666667,11 Z M16.3334309,3 C16.7015669,3 17,3.29817125 17,3.66468676 L17,7.66864657 C17,8.03574293 16.7033691,8.33333333 16.3334309,8.33333333 L5.66656909,8.33333333 C5.29843315,8.33333333 5,8.03516208 5,7.66864657 L5,3.66468676 C5,3.2975904 5.29663086,3 5.66656909,3 L16.3334309,3 Z M15.6666667,4.33333333 L6.33333333,4.33333333 L6.33333333,7 L15.6666667,7 L15.6666667,4.33333333 Z" id="Rectangle-560"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatTable extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
